import { runInAction } from "mobx"
import { useEffect } from "react"

import { useRootContext } from "@/hooks/useRootContext.ts"

export function useGlobalLoader(result: FetchableResult | boolean) {
  const context = useRootContext()
  const loading = isLoadingOrFetching(result)

  useEffect(() => {
    runInAction(() => {
      context.isLoading.set(loading)
    })

    return () => {
      runInAction(() => {
        context.isLoading.set(false)
      })
    }
  }, [context.isLoading, loading])
}

type FetchableResult = {
  isLoading: boolean
  isFetching: boolean
}

export function isLoadingOrFetching(result: FetchableResult | boolean) {
  return typeof result === "boolean" ? result : result.isLoading || result.isFetching
}

